const actionLogger = store => next => action => {

    console.group(action.type + ' ' + getTimeString())
    console.info('dispatching', action)
    let result = next(action)
    console.log('next state', store.getState())
    console.groupEnd()
    return result
}

function getTimeString() {
    var date = new Date();
    var min = "" + date.getMinutes();
    var sec = "" + date.getSeconds();
    var mil = "" + date.getMilliseconds();
    if (mil.length === 1) mil = "00" + mil;
    if (mil.length === 2) mil = "0" + mil;
    var x = "" + date.getHours() + ":" + (min.length === 1 ? "0" + min : min) + ":" + (sec.length === 1 ? "0" + sec : sec) + "." + mil;
    return x;
}


export default actionLogger